<template>
  <div>
    <footer class="footer">
      <div class="clearfix"></div>
      <div class="icon-row">
        <div class="footer-icon">
          <h5 class="footer-icon-child"></h5>
          <span class="footer-icon-text">多年临床，安全放心</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-2"></h5>
          <span class="footer-icon-text">多仓直发，极速配送</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-3"></h5>
          <span class="footer-icon-text">厂家授权，品质保证</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-4"></h5>
          <span class="footer-icon-text">海关备案，正规进口</span>
        </div>
      </div>
      <div class="service-intro">
        <div class="servece-type">
          <div class="servece-type-box">
            <div
              class="servece-type-info"
              v-for="(guide, index) in guideArr"
              :key="index"
            >
              <ul>
                <li
                  v-for="(item, index) in guide"
                  :key="index"
                  @click="goToHelp"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
          <div class="servece-phone">
            <div class="phone">
              <div>联系电话</div>
              <div>亚洲：00852-81981712</div>
              <div>英国：00(44)208-133-0051</div>
              <div>日本: 00(81)503-136-5566</div>
              <div>瑞士:0041-43-5080985</div>
              <div>北美:001(206)317-1630</div>
            </div>
            <div class="phone email">
              <div>联系邮箱</div>
              <div>邮箱：service@drogn.cn</div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>

        <div class="friend-link">
          <div class="friend-link-item" style="text-align:center;">
            Copyright © 2014-2025 五洲药物版权所有 自营经营者信息<a href="https://www.wuzhou.mo/_nuxt/img/shangyedengji.598bb3f.jpg" target="blank">自营经营者信息</a> 
          </div>
        </div>

        <div class="clearfix"></div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      linkItemClass: "link-item",
      guideArr: [
        ["购物指南", "购物流程", "会员介绍"],
        ["配送方式", "配送服务查询", "收取标准", "海外配送"],
        ["支付方式", "货到付款", "在线支付"],
        [
          "售后服务",
          "售后政策",
          "价格保护",
          "退款说明",
          "返修/退换货",
          "取消订单"
        ]
      ],
      moreLink: [
        "关于我们",
        "联系我们",
        "联系客服",
        "合作招商",
        "商家帮助",
        "营销中心",
        "销售联盟",
        "校园社区",
        "风险监测",
        "隐私政策"
      ]
    };
  },
  methods: {
    goToHelp() {
      this.$router.push({
        path: "/helpCenter"
      });
    },
    toKefu(link) {
      if (link === "联系客服") {
        window.location.href = `https://wpa1.qq.com/kHYHvUz1?_type=wpa&qidian=true`;
      }
    }
  }
};
</script>

<style scoped>
.footer {
  width: 100%;
  height: 300px;
  background-color: #eaeaea;
}
.icon-row {
  margin: 15px auto;
  padding-top: 8px;
  width: 1000px;
  height: 64px;
  display: flex;
  justify-content: space-between;
}
.footer-icon {
  margin-left: 17px;
  margin-right: 17px;
  float: left;
}
.footer-icon-child {
  margin-top: 17px;
  overflow: hidden;
  position: absolute;
  width: 26px;
  height: 26px;
  background-image: url("../../../assets/pc/images/footer/1-icon.png");
  background-repeat: no-repeat;
  background-size: 100%;
  text-indent: -999px;
}
.footer-icon-child-2 {
  background-image: url("../../../assets/pc/images/footer/2-icon.png");
  margin-top: 20px;
}
.footer-icon-child-3 {
  background-image: url("../../../assets/pc/images/footer/3-icon.png");
}
.footer-icon-child-4 {
  background-image: url("../../../assets/pc/images/footer/4-icon.png");
  margin-top: 18px;
}
.footer-icon-text {
  margin-left: 40px;
  color: #444444;
  font-size: 18px;
  font-weight: bold;
  line-height: 64px;
}
.service-intro {
  width: 100%;
  border-top: 1px solid #b2dfdb;
}
.servece-type {
  margin: 15px auto;
  height: 180px;
  width: 880px;
  display: flex;
}
.servece-type-box {
  display: flex;
  width: 60%;
}
.servece-type-info {
  color: #666666;
  width: 30%;
}
.servece-type-info ul {
  list-style: none;
}
.servece-type-info li {
  font-size: 12px;
  cursor: pointer;
  line-height: 26px;
}
.servece-type-info li:first-child {
  font-size: 16px;
  line-height: 28px;
  color: #000;
  /* font-weight: bold; */
}
.servece-phone {
  border-left: 1px solid #e6e6e6;
  padding-left: 80px;
  margin-bottom: 20px;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  width: 600px;
}
.servece-phone .phone {
  color: #000;
  font-size: 16px;
  line-height: 30px;
}
.servece-phone .phone div:last-child {
  /* font-size: 20px; */
}
.servece-phone .email {
  margin-top: 10px;
}
.friend-link {
  display: flex;
  align-items: center;
  width: 908px;
  height: 30px;
  margin: 0px auto;
  color: #666;
  border-top: 1px solid #b2dfdb;
}
.friend-link-item {
  width: 100%;
}
.friend-link-item ul {
  list-style: none;
  display: flex;
  justify-content: space-between;
}
.friend-link-item li {
  padding: 2px 0px;
  float: left;
  color: #fff;
  background-color: rgb(45, 140, 253);
}

.link-item {
  padding: 0px 8px;
  cursor: pointer;
  color: #000;
}
.friend-link-item li span {
  color: #fff;
}
.link-last-item {
  border: none;
}
.copyright {
  width: 100%;
  color: #666;
  line-height: 30px;
  text-align: center;
}
.copyright a {
  color: #232323;
  font-size: 20px;
}
</style>
